var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadCrumb',{attrs:{"data":_vm.breadCrumb}}),_c('Panel',{attrs:{"morePanel":_vm.morePanels,"loading":_vm.loading,"data":_vm.panels,"search":_vm.searchPanel,"type":_vm.type,"changeType":_vm.changeType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }